export const trackGtmEvent = (eventName, eventData) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    })
  } else {
    console.warn('Google Tag Manager dataLayer is not available.')
  }
}
